module.exports = __webpack_public_path__ + "static/media/social.d1c6c705.png";